import { gql } from '@apollo/client'

import { CUSTOMER_FRAGMENT } from '../fragments'

export const GET_CURRENT_CUSTOMER = gql`
  query CurrentCustomer {
    currentCustomer {
      ...Customer
    }
  }
  ${CUSTOMER_FRAGMENT}
`
